import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { primaryBlockDefaultStyles } from "@circle-react-shared/BuilderUI/DefaultBlocks/Homepage/constants";
import { useTopBlockStyles } from "@circle-react-shared/BuilderUI/Hooks/useTopBlockStyles";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export interface AboutUsBlock4Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  cards: ReactNode;
  content: ReactNode;
  header: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const AboutUsBlock4 = forwardRef<HTMLDivElement, AboutUsBlock4Props>(
  ({ header, content, cards, className, styles, ...rest }, ref) => {
    const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles(
      {
        styles,
        defaultStyles: primaryBlockDefaultStyles,
      },
    );

    return (
      <BlockSection ref={ref} className={className} {...rest}>
        <BlockSection.Background style={backgroundStyles}>
          <BlockSection.Container>
            <BlockSection.Content
              style={{
                ...paddingStyles,
                ...marginStyles,
              }}
            >
              <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-4 wb-items-center wb-text-center md:wb-gap-5">
                {header}
              </BlockSection.NestedBlock>
              <div className="wb-flex wb-flex-col wb-gap-8 md:wb-gap-12">
                <BlockSection.NestedBlock>{content}</BlockSection.NestedBlock>
                <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-gap-8 md:wb-grid md:wb-grid-cols-2 xl:wb-grid-cols-4 md:wb-items-center wb-mx-auto">
                  {cards}
                </BlockSection.NestedBlock>
              </div>
            </BlockSection.Content>
          </BlockSection.Container>
        </BlockSection.Background>
      </BlockSection>
    );
  },
);

AboutUsBlock4.displayName = "AboutUsBlock4";
